/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { SxProps, Theme } from '@mui/material';
import { NewFormTextField } from '../../../../presentation';
import { useFormContext } from 'react-hook-form';
import { TaskType } from '@converge/graphql';

export interface TaskTextFieldProps {
  taskId: string;
  onChange: (taskId: string, value: string) => void;
  onUpsertTask?: (taskId: string, value: string, taskType?: TaskType) => any;
  taskType?: string;
  /** Initial value for the task name */
  initialValue?: string;
  /** Whether the field should be disabled */
  disabled?: boolean;
  /** Custom styling */
  sx?: SxProps<Theme>;
  isNotActive?: boolean;
}

export const TaskTextField = ({
  taskId,
  onChange,
  onUpsertTask,
  taskType = 'ADDITIONAL_TASK',
  initialValue,
  disabled = false,
  isNotActive,
  sx,
}: TaskTextFieldProps) => {
  const [originalValue, setOriginalValue] = useState(initialValue || '');

  const { getValues } = useFormContext();

  useEffect(() => {
    const formValue = getValues(`task-${taskId}`);
    if (formValue) {
      setOriginalValue(formValue);
    }
  }, [taskId, getValues]);

  const handleBlur = (event?: React.BaseSyntheticEvent) => {
    if (!event) return;

    const value = (event.target as HTMLInputElement).value.trim();

    const isDirty = value !== originalValue;

    if (value && isDirty && onUpsertTask) {
      onUpsertTask(taskId, value, taskType as TaskType);

      setOriginalValue(value);
    }

    onChange(taskId, value);
  };

  return (
    <NewFormTextField
      name={`task-${taskId}`}
      containerWidth={16}
      placeholder="Enter task"
      onBlur={disabled ? undefined : handleBlur}
      disabled={disabled}
      className={isNotActive ? 'task-field-inactive' : ''}
      sx={sx}
    />
  );
};

export default TaskTextField;
